import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const CommandItemProcessesPage = lazy(() => import('@/containers/Views/CommandItemProcesses/CommandItemProcessesPage'));

const CommandItemProcessesRouter = (
  <Route path="command_item_processes">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.EstablishmentConfigurations} 
          permissions={EBasicActions.Find}
        >
          <CommandItemProcessesPage />
        </PrivateRoute>
      )} 
    />
  </Route>
);

export default CommandItemProcessesRouter;
